import palette from '@lib/core/src/theme/palette';
import { motion } from 'framer-motion';

import Markdown from '@/utils/Markdown';

interface ThoughtsProps {
  thoughts: string[];
}

const Thoughts = ({ thoughts }: ThoughtsProps) => (
  <motion.div
    style={{ color: palette.grey[400] }}
    key="thoughts"
    initial={{ opacity: 0, height: 0 }}
    animate={{ opacity: 1, height: 'auto' }}
    exit={{ opacity: 0, height: 0 }}
    transition={{
      ease: 'easeInOut',
      exit: {
        opacity: { duration: 0.05 },
        height: { duration: 0.5 }
      }
    }}
  >
    <motion.div
      style={{ color: palette.grey[400] }}
      animate={{ opacity: [0.6, 1, 0.6] }}
      transition={{
        ease: 'easeInOut',
        repeat: Infinity,
        duration: 1.4
      }}
    >
      {thoughts.map((thought, index) => (
        <Markdown key={index}>{thought}</Markdown>
      ))}
    </motion.div>
  </motion.div>
);

export default Thoughts;
